import { useState } from 'react';

export const useReload = () => {
  const [count, setCount] = useState(0);
  return [count, () => setCount((prev) => prev + 1)] as [number, VoidFunction];
};
